import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import itemsModules, { reusableItems } from '../ItemsModules/itemsFilter';
import TitleLineH1 from './TitleLineH1';
import CollapsibleListComponent from './CollapsibleListComponent';
import ReusableComponent from './ReusableComponent';
import Separator from './Separator';
import ArtistsList from './ArtistsList';
import CollapsibleFAQs from './CollapsibleFAQsComponents/CollapsibleFAQs';
import ContactForm from './ContactFormReusable';
import FullLink from './FullLink';
import GalleryModule from './GalleryModule';
import ImageModule from './ImageModule';
import InstructionsModule from './InstructionsModule';
import Launcher from './Launcher';
import LogosRowModule from './LogosRowModule';
import MapModule from './MapModule';
import MediaTitle from './MediaTitle';
import ParagraphModule from './ParagraphModule';
import PostDescriptionRow from './PostDescriptionRow';
import SpotifyPlayer from './SpotifyPlayer';
import TitleLineH2 from './TitleLineH2';
import Tickets from './Tickets';
import VideoPlayerModule from './VideoPlayerModule';
import TagsRow from './TagsRow';
import LineupContainer from './LineupContainer';

import { move, copy, reorder } from '../../../../utils/dragAndDrop';
import Modal from '../../../Modal/Modal';
// styles

const initialState = {
  type: 'FilterHolder',
  name: {
    text: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    category: '',
    value: '',
  },
  components: [],
};

const grid = 4;

const getItemStyleContent = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  color: 'white',
  margin: `0 ${grid}px 0 0`,
  borderRadius: '4px',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '#292929',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getItemStyleType = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 4,
  border: '1px solid #dae1e7',
  margin: '2% 1% 0.5%',
  borderRadius: '10px',
  // change background colour if dragging
  background: 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyleContent = isDraggingOver => ({
  background: 'black',
  padding: '10px 16px',
});

const getListStyleType = (isDraggingOver, selected) => ({
  background: isDraggingOver ? 'transparent' : 'transparent',
  border: '2px dashed #c8c8c8',
  borderRadius: '10px',
  paddingRight: '0rem',
  width: '100%',
  paddingBottom: '5px',
  minHeight: '100px',
});

const FilterHolder = ({
  handleReadableNameReusable, toggleRefetch, activeLanguage, handlerSetSliderComponents, handlerSetSlider, components, id, reusableComponent, reusableComponentSlugname, languages, reusableComponents,
}) => {
  const [selected, setSelected] = useState([]);
  const [selectedRight, setSelectedRight] = useState([]);
  const [items, setItems] = useState(itemsModules);
  const [reusableitems] = useState(reusableItems);
  const [sliderIndex, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isModalOn, setModalState] = useState(false);
  const [filterName, setFilterName] = useState(initialState.name);
  const [isVisibleComponents, setIsVisibleComponents] = useState(false);
  const [isVisibleReusables, setIsVisibleReusables] = useState(false);
  const handlerSetNestedComponentsLeft = (comp, index) => {
    const { component } = comp;
    selected[index].component = {
      ...component,
    };

    const newSelected = selected;
    newSelected[index].component = { ...component };

    setSelected(newSelected);
    handlerSetSliderComponents(
      {
        ...state,
        components: newSelected,
      },
      sliderIndex,
    );
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
      setFilterName(component.name);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetSlider(componentObj, componentIndex);
    }
    if (components[componentIndex]) {
      const sliderComponent = components[componentIndex].component;

      if (sliderComponent) {
        setSelected(sliderComponent.components);
      }
    }
  }, [components]);

  const handleBlockClose = (componentId) => {
    const componentToBeRemovedIndex = selected.findIndex(obj => obj.id === componentId);
    const arr = [...selected];
    arr.splice(componentToBeRemovedIndex, 1);
    setSelected(arr);
    handlerSetSliderComponents(
      {
        ...state,
        components: arr,
      },
      sliderIndex,
    );
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;
    setIsVisibleReusables(false);
    setIsVisibleComponents(false);
    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        let newOrder;
        if (destination.droppableId === 'selected') {
          newOrder = reorder(selected, source.index, destination.index);
          setSelected(newOrder);
          handlerSetSliderComponents(
            {
              ...state,
              components: newOrder,
            },
            sliderIndex,
          );
        }
        break;
      }
      case 'items': {
        const makeCopy = copy(items, selected, source, destination);
        setSelected(makeCopy);
        break;
      }
      case 'reusable': {
        const makeCopy = copy(reusableitems, selected, source, destination);
        setSelected(makeCopy);
        break;
      }
      default: {
        let movedElements;
        if (source.droppableId === 'selected') {
          movedElements = move(selected, selectedRight, source, destination);
        }
        setSelected(movedElements.selected);
        setSelectedRight(movedElements.selectedRight);
        handlerSetSliderComponents(
          {
            ...state,
            components: movedElements.selected,
            right: movedElements.selectedRight,
          },
          sliderIndex,
        );
      }
    }
  };

  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const setFilterFromModal = () => {
    setModalState(false);
    const comp = {
      ...state,
      components: [],
      name: filterName,
    };
    setState(comp);
    handlerSetSliderComponents(
      {
        ...state,
        name: filterName,
      },
      sliderIndex,
    );
  };

  const nameInputHandler = (e) => {
    const { value, name } = e.target;
    if (name === 'text') {
      const langText = {
        ...filterName,
        text: {
          ...filterName.text,
          [activeLanguage.toLowerCase()]: value,
        },
      };
      setFilterName(langText);
    } else {
      setFilterName({ ...filterName, [name]: value });
    }
  };

  return (
    <>
      <div className="ml-8 relative">
        <div className="flex justify-between items-center my-2">
          {languages.map(lang => (
            <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block ml-4 flex flex-row' : 'hidden'}`}>
              {state.name.text[activeLanguage] && (
              <span className="text-black font-americaMonoRegular text-xs uppercase font-bold">
                Filter:
                {' '}
                <button type="button" className={`text-black uppercase text-xs font-americaMonoRegular rounded-lg mr-2 mb-2 shadow-white py-2 px-5 bg-${state.name.category} shadow-none`}>{state.name.text[activeLanguage]}</button>
              </span>
              )}
              <button className="font-americaMonoBold text-xs pl-6 pr-5 py-2 rounded-full uppercase bg-greyFilter right-0 flex flex-row items-center mr-4 h-10" type="button" onClick={toggleModal}>
                {state && state.name.text[activeLanguage] ? 'Change filter' : 'Set filter'}
                {state && state.name.text[activeLanguage] ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-black" /> : <span className="font-icon icon-add-button text-base font-bold pl-2" />}
              </button>
            </div>
          ))}

        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="w-full flex flex-col justify-between pr-2 pb-3">
            {state && state.name.text
        && (
        <div className="w-full flex bg-black p-4">
          <Droppable droppableId="items" isDropDisabled>
            {(provided, snapshot) => (
              <div className="flex -ml-px" ref={provided.innerRef}>
                <div id="module-button" className="mr-2 mb-0 cursor-pointer px-1 py-2 h-50px items-center flex rounded-lg" style={{ background: 'rgb(41, 41, 41)' }} onClick={() => { setIsVisibleComponents(!isVisibleComponents); setIsVisibleReusables(false); }}>
                  Components
                </div>
                {isVisibleComponents
                && (
                <ul className="pin-t pin-r h-64 z-top overflow-y-scroll list-none p-4 bg-black mr-4 mx-0 px-0">
                  <button
                    className="absolute pin-r pin-t mt-2 mr-2 h-4 w-4 flex items-center justify-center bg-black rounded-full"
                    type="button"
                    onClick={() => setIsVisibleComponents(!isVisibleComponents)}
                  >
                    <span className="font-icon icon-close-btn1 text-base text-white" />
                  </button>
                  {items.map((item, index) => (
                    <li key={item.id} className="mb-1">
                      <Draggable draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div className="mr-2 mb-0 p-2" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                            {item.readableName}
                          </div>
                        )}
                      </Draggable>
                    </li>
                  ))}
                </ul>
                )
}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          <Droppable droppableId="reusable" isDropDisabled>
            {(provided, snapshot) => (
              <div className="flex rounded-r-lg flex-col" ref={provided.innerRef}>
                <div id="module-button" className="mb-0 cursor-pointer px-1 py-2 h-50px items-center flex rounded-lg" style={{ background: 'rgb(41, 41, 41)' }} onClick={() => { setIsVisibleReusables(!isVisibleReusables); setIsVisibleComponents(false); }}>
                  Reusables
                </div>
                {isVisibleReusables
                && (
                <ul className="pin-t pin-r h-64 z-top overflow-y-scroll list-none p-4 bg-black mr-4 mx-0 px-0">
                  <button
                    className="absolute pin-r pin-t mt-2 mr-2 h-4 w-4 flex items-center justify-center bg-black rounded-full"
                    type="button"
                    onClick={() => setIsVisibleReusables(!isVisibleReusables)}
                  >
                    <span className="font-icon icon-close-btn1 text-base text-white" />
                  </button>
                  {reusableitems.map((item, index) => (
                    <li key={item.id}>
                      <Draggable draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div id="module-button" className="mr-2 mb-0" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                            {item.readableName}
                          </div>
                        )}
                      </Draggable>

                    </li>
                  ))}
                </ul>
                )
}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
        )}
            {state && state.name.text && (
            <div className="pl-2 mt-4 w-full h-full flex">
              <Droppable droppableId="selected">
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} style={getListStyleType(snapshot.isDraggingOver, selected)}>
                    {selected.length > 0
                      && selected.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index} activeLanguage={activeLanguage}>
                          {(provided, snapshot) => (
                            <div id={`left-content${index}`} ref={provided.innerRef} {...provided.draggableProps} style={getItemStyleType(snapshot.isDragging, provided.draggableProps.style)} className="relative">
                              <div className="bg-greyFilterItems text-grey-avatar absolute h-full px-1 z-10 pin-l pin-t flex items-center justify-center " {...provided.dragHandleProps}>
                                =
                              </div>
                              <button className="absolute pin-l pin-t" style={{ marginTop: '-20px', marginLeft: '2px' }} type="button">
                                <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded">{item.readableName}</span>
                              </button>
                              <button
                                className="absolute pin-r pin-t h-4 w-4 flex items-center justify-center bg-black rounded-full"
                                style={{ marginTop: '-20px', marginRight: '2px' }}
                                type="button"
                                onClick={() => {
                                  handleBlockClose(item.id);
                                }}
                              >
                                <span className="font-icon icon-close-btn1 text-base text-white -mt-px" />
                              </button>

                              {item.content === 'TitleLineH1' && <TitleLineH1 id={item.id} languages={languages} components={selected} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} />}
                              {item.content === 'CollapsibleList' && <CollapsibleListComponent id={item.id} languages={languages} reusableComponents={reusableComponents} components={selected} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} />}
                              {item.content === 'Launcher' && <Launcher id={item.id} languages={languages} components={selected} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} />}
                              {item.content === 'Separator' && <Separator languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'TagsRow' && <TagsRow languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'LineupContainer' && <LineupContainer languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'TitleLineH2' && <TitleLineH2 languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'SpotifyPlayer' && <SpotifyPlayer handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {(item.content === 'MediaTitle' || item.content === 'DoubleTitle') && <MediaTitle languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'NormalBodyText' && <ParagraphModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'PostDescriptionRow' && <PostDescriptionRow languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'LogosRowModule' && <LogosRowModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'MediaDescription' && <ImageModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'Gallery' && <GalleryModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} reusableComponentSlugname={item.reusableCompSlugName} toggleRefetch={toggleRefetch} />}
                              {item.content === 'CarouselWithDescription' && <GalleryModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} reusableComponentSlugname={item.reusableCompSlugName} toggleRefetch={toggleRefetch} isCarousel />}
                              {item.content === 'FullLink' && <FullLink languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'VideoPlayer' && <VideoPlayerModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'LineupContainerSimple' && <CollapsibleFAQs languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'CarouselTickets' && <Tickets languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {(item.content === 'InstructionsSimpleUploadLogo' || item.content === 'InstructionsSimple') && <InstructionsModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'Map' && <MapModule handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'Tickets' && <Tickets languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'LineupList' && <ArtistsList languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {item.content === 'ContactFormReusable' && <ContactForm handlerSetComponents={handlerSetNestedComponentsLeft} id={item.id} components={selected} />}
                              {/* {item.type === 'reusableItem' && <ReusableComponent id={item.id} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} content={item.content} components={selected} handleReadableNameReusable={handleReadableNameReusable} toggleRefetch={toggleRefetch} />} */}
                              {/* {item.type === 'reusableItem' && <ReusableComponent id={item.id} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} content={item.content} components={selected} handleReadableNameReusable={handleReadableNameReusable} toggleRefetch={toggleRefetch} />} */}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
            )}
          </div>
        </DragDropContext>
      </div>
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="10" title="Set filter text">
          <div className="mb-6 mt-4 ml-2">
            <div className="flex flex-wrap w-full">
              <label className="font-americaMonoRegular uppercase text-white w-1/3 sm:w-full px-1" htmlFor="category">
                Category
                <input className="font-americaMonoRegular bg-white outline-none w-full rounded-full w-full p-3 mt-1" onChange={nameInputHandler} id="category" name="category" type="text" placeholder="category" value={filterName.category || ''} />
              </label>
              <label className="font-americaMonoRegular uppercase text-white w-1/3 sm:w-full px-1" htmlFor="text">
                Text
                <input className="font-americaMonoRegular bg-white outline-none rounded-full w-full p-3 mt-1" onChange={nameInputHandler} name="text" type="text" placeholder="Filter text" value={filterName.text[activeLanguage] || ''} />
              </label>
              <label className="font-americaMonoRegular uppercase text-white w-1/3 sm:w-full px-1" htmlFor="value">
                Value
                <input className="font-americaMonoRegular bg-white outline-none w-full rounded-full p-3 mt-1" onChange={nameInputHandler} name="value" type="text" placeholder="Filter value" value={filterName.value || ''} />
              </label>
            </div>
            <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter ml-1 mt-4" type="button" onClick={setFilterFromModal}>
              Set filter
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FilterHolder;
